import { faBan } from '@fortawesome/pro-regular-svg-icons'
import { Text } from '@mantine/core'
import { useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreInquiry } from '@flecto/types'
import { Modal } from '@flecto/ui'

import { useInquiryActions } from '../../hooks/useInquiryActions'
import { SectionInquiryNotification } from '../SectionInquiryNotification/SectionInquiryNotification'

export type ModalRejectInquiryProps = {
  inquiry?: CoreInquiry
}

export function ModalRejectInquiry({ inquiry }: ModalRejectInquiryProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })

  const [sendEmail, setSendEmail] = useState(false)

  const { handleReject } = useInquiryActions({ inquiry })

  console.log(inquiry)

  return (
    <Modal>
      <Modal.Icon icon={faBan} color='red' />
      <Modal.Title>{t('modal.reject_title')}</Modal.Title>
      <Modal.Subtitle>{t('modal.reject_description')}</Modal.Subtitle>
      <Modal.Content>
        <Text>{t('modal.reject_notification_description')}</Text>

        <SectionInquiryNotification
          mt='lg'
          inquiry={inquiry}
          value={sendEmail}
          onChange={setSendEmail}
        />
      </Modal.Content>
      <Modal.Cancel />
      <Modal.Submit onClick={() => handleReject(sendEmail)}>
        {t('label_confirm')}
      </Modal.Submit>
    </Modal>
  )
}
